import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap"
import ToastDialog from "common/ToastDialog"
import Initialform from "./initial"
import {
  getDealerById,
} from "helpers/UAM/dealer.helper"
import { isEmpty } from "lodash"
import Contacts from "./tabs/Contacts"
import OtherDetails from "./tabs/otherDetails"
import Address from "./tabs/Address"
import SalesOffice from "./tabs/SalesOffice"

const AddDealer = props => {
  // Routes vars
  const { id } = useParams()

  const dealerId = !isEmpty(id) ? atob(id) : null

  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [dealerData, setDealerData] = useState([])

  let title = "Add Dealer"

  if (!isEmpty(dealerId)) {
    title = "View Dealer"
  }
  const navigate = useNavigate()
  document.title = title

  async function getDealerInfo(dealerId) {
    const response = await getDealerById({ id: dealerId })
    if (response.status) {
      setDealerData(response?.data)
    } else {
      setToastInfo({
        message: response.message,
        showToast: true,
        role: "error",
      })
    }
  }

  useEffect(() => {
    if (!isEmpty(dealerId)) {
      getDealerInfo(dealerId)
    }
  }, [dealerId])

  const handleCancel = () => {
    navigate(-1)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box pb-2 d-flex gap-3 justify-content-between align-items-center">
            <h4 className="mb-sm-0 font-size-18">View Dealer</h4>
            <div>
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={handleCancel}
              >
                Back
              </button>
            </div>
          </div>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <Initialform dealerData={dealerData} />
                  <div className="mt-2 border-top">
                    <hr />
                    <div className="divider-line bg-danger "></div>
                    <OtherDetails partnerDetails={dealerData.dealerPartners} />
                  </div>
                  <div className="mt-2 border-top">
                    <hr />
                    <Address dealerAddress={dealerData?.address} />
                  </div>
                  <div className="mt-2 border-top">
                    <hr />
                    <SalesOffice
                      dealerData={dealerData}
                      getDealerInfo={getDealerInfo}
                    />
                  </div>
                  <div className="mt-2 border-top">
                    <hr />
                    <Contacts dealerData={dealerData} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  )
}

export default AddDealer
